import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StatesService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get all site configuration
  getStates(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'states';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
